import Buttons from "./Buttons";
import Inputs from "./Inputs";
import FormGroups from "./FormGroups";
import CurrentView from "./CurrentView";
import Alerts from "./Alerts";
import ModalParts from "./ModalParts";
import Modals from "./Modals";

export default {
  Buttons,
  Inputs,
  FormGroups,
  CurrentView,
  ModalParts,
  Alerts,
  Modals
};



// WEBPACK FOOTER //
// ./src/Core/Components/index.js